function SectionHeading({ eyebrow, title, text }) {
  return (
    <header className="section-heading">
      {eyebrow && <p className="section-heading__eyebrow">{eyebrow}</p>}
      <h2>{title}</h2>
      {text && <p>{text}</p>}
    </header>
  );
}

export default SectionHeading;
